import deepCopy from '@util/copy'
// eslint-disable-next-line no-unused-vars
import { GetTrip, GetTripAllOf, Trip, TripMutation } from '@clients/myTrips'

export function tripToTripMutation (trip: GetTrip | Trip): TripMutation {
  if (trip) {
    const mutation = {
      ...deepCopy(trip),
      pilotId: trip.pilot && trip.pilot.id,
      tagId: trip.tag && trip.tag.id
    } as TripMutation

    if (!trip.endInfo) {
      mutation.endInfo = {
        location: null,
        address: null,
        odometer: null,
        timestamp: null
      }
    }

    return mutation
  }
}

export const tripEventsMapping = [
  {
    type: 'ieu.dfb2.acc.l',
    name: 'Starke Beschleunigungen',
    icon: {
      name: 'icon-event-accelerate',
      height: 22,
      width: 22,
      viewBox: '4.5 3 22 22'
    }
  },
  {
    type: 'ieu.dfb2.dec.l',
    name: 'Starke Bremsungen',
    icon: {
      name: 'icon-event-brake',
      height: 22,
      width: 22,
      viewBox: '4.5 2 22 22',
    }
  },
  {
    type: 'ieu.dfb2.cnrr.l',
    name: 'Scharfe Rechtskurve',
    icon: {
      name: 'icon-event-right',
      height: 22,
      width: 22,
      viewBox: '4 4 22 22'
    }
  },
  {
    type: 'ieu.dfb2.cnrl.l',
    name: 'Scharfe Linkskurve',
    icon: {
      name: 'icon-event-left',
      height: 22,
      width: 22,
      viewBox: '4 4 22 22'
    }
  },
  {
    type: 'ieu.dfb2.spd.start',
    name: 'Anfang der Geschwindigkeitsüberschreitung',
    icon: {
      name: 'icon-event-overspeed',
      class: ['tint-green'],
      viewBox: '0 100 1000 1000'
    }
  },
  {
    type: 'ieu.dfb2.spd',
    name: 'Ende der Geschwindigkeitsüberschreitung',
    icon: {
      name: 'icon-event-overspeed',
      class: ['tint-red'],
      viewBox: '0 100 1000 1000'
    }
  },
]
